/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PcObjectStringConvert {
  public convertStringBooleansToBooleans(obj: any): any {
    if (typeof obj !== 'object' || obj === null) {
      return obj;
    }

    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (typeof value === 'string') {
        const lowerValue = value.toLowerCase();
        if (lowerValue === 'true') {
          acc[key] = true;
        } else if (lowerValue === 'false') {
          acc[key] = false;
        } else {
          acc[key] = value;
        }
      } else if (typeof value === 'object' && value !== null) {
        acc[key] = this.convertStringBooleansToBooleans(value);
      } else {
        acc[key] = value;
      }
      return acc;
    }, {} as any);
  }
}
